import Breadcrumb from '../Component/Breadcrumb'
const Smc = () => {
    return (
        <>
            <Breadcrumb breadtitle="School Managing Committee" breadmid="About" breadend="School Managing Committee" />
            <div className="innerpage">
                <div className="container">
                    <div className="row">
                        <div class="col-md-4">
                            <div class="box">
                                <h4>Total Area (in Sq. Mtrs.)</h4>
                                <h5><span>5200 sq. mtrs.</span></h5>
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="box">
                                <h4>Built Up Area (in Sq. Mtrs.)</h4>
                                <h5><span>2662 sq. mtrs.</span></h5>
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="box">
                                <h4>Area of Playground (in sq. Mtrs.)</h4>
                                <h5><span>3862 sq. mtrs.</span></h5>
                            </div>
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-md-12'>
                        <div class="table-responsive">
            <table className="table">
                <thead>
<tr>
<td width="20%"><b>S.No.</b></td>
                  <td width="40%"><b>Name</b> </td>
                  <td width="40%"><b>Designation</b></td>
</tr>
                </thead>
              <tbody>
                <tr>
                  <td>1</td>
                  <td>Sr. Philo Lobo</td>
                  <td>Chairman</td>
                </tr>
                <tr>
                  <td>2</td>
                  <td>Sr. Rosy</td>
                  <td>Secretary</td>
                </tr>
                <tr>
                  <td>3</td>
                  <td>Fr. Anil Parker</td>
                  <td>Principal CBSE</td>
                </tr>
                <tr>
                  <td>4</td>
                  <td>Br. Joy Thomas</td>
                  <td>Principal CBSE</td>
                </tr>
                <tr>
                  <td>5</td>
                  <td>Dr. Paul Mathew</td>
                  <td>Professor I T College</td>
                </tr>
                <tr>
                  <td>6</td>
                  <td>Mrs. Meena Lobo</td>
                  <td>Teacher, La Martiniere</td>
                </tr>
                <tr>
                  <td>7</td>
                  <td>Mr. Ambrish Kumar</td>
                  <td>Parent Representative (Male)</td>
                </tr>
                <tr>
                  <td>8</td>
                  <td>Mrs. Najma Parveen</td>
                  <td>Parent Representative (Female)</td>
                </tr>
                <tr>
                  <td>9</td>
                  <td>Mrs. Neetu Srivastava</td>
                  <td>Teacher representative</td>
                </tr>
                <tr>
                  <td>10</td>
                  <td>Mrs Meena Srivastava</td>
                  <td>Teacher representative</td>
                </tr>
                <tr>
                  <td>11</td>
                  <td>Sr. Nirmala Martin</td>
                  <td>Member</td>
                </tr>
                <tr>
                  <td>12</td>
                  <td>Sr. Divya Ekka</td>
                  <td>Member</td>
                </tr>
                <tr>
                  <td>13</td>
                  <td>Sr. Latha Thankapan</td>
                  <td>Member</td>
                </tr>
                <tr>
                  <td>14</td>
                  <td>Sr. Elsy</td>
                  <td>Member</td>
                </tr>
                <tr>
                  <td>15</td>
                  <td>Sr. Germaine Carvalho </td>
                  <td>Member</td>
                </tr>
              </tbody>
            </table>
          </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
export default Smc